
import React, { useEffect, useState, useMemo } from 'react';
import axios from 'src/axios';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Checkbox,
  useStepContext,
  FormHelperText,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { ListItemText } from '@mui/material';
import Iconify from 'src/components/Iconify';
import Page from 'src/components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import {
  CardContent,  
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableHead,
} from '@mui/material';
import { getGroups,getClientInfo,AddClientGroupName,AddClientGroup } from 'src/api/groups';
import { getClientList } from 'src/api/analytics';
import { getDevices } from 'src/api/devices';
import GroupsMore from './GroupsMore';
import { CameraEnhance } from '@mui/icons-material';
import { iteratee } from 'lodash';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { tr } from 'date-fns/locale';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { getGroupsByClient } from 'src/api/liveCameras';
import { getClientProperties } from 'src/api/ShiftMaster';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Groupsdetails= ({isReseller}) => {
  
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const effectiveResellerClientType = resellerClientType === 'INDIA' ? 'INDIA' : 'US';
  const [data, setData] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [selectedClient, setSelectedClient] = useState(null); // State for selected client
  const [clientInfo, setClientInfo] = useState([]); // State for storing client data
  const [clientOptions, setClientOptions] = useState([]); // State for autocomplete options
  const [client, setClient] = useState('');
  const [camera, setCamera] = useState('');
  const [group, setGroup] = useState([]);
  const [clientGroups,setClientGroups] = useState([])
  const [groupName, setGroupName] = useState("");
  const [open, setOpen] = useState(false);
  const [openError,setOpenError]=useState(false)
  const [errorMessageOpen, setErrorMessageOpen] = useState(false);
  const [selectedCameras, setSelectedCameras] = useState([]);
  const [clientData,setClientData]=useState([])
  const [devices,setDevices]=useState([])
  const [clientCameras,setClientCameras]=useState([])
  const [selectedGroup,setSelectedGroup]=useState(null)
  const [reloadGroups,setReloadGroups]=useState(false)
  const [message,setMessage]=useState('')
  
  const [groupNameError, setGroupNameError] = useState(false);
  const [clientNameError, setClientNameError] = useState(false);
  const [clientError, setClientError] = useState(false);

  const [clientMessage,setClientMessage] = useState('')
  const [clientNameMessage,setClientNameMessage] = useState('')

  const [helperText,setHelperText] = useState('');
  const [activeCameras, setActiveCameras] = useState([])
  const [inputValue, setInputValue] = useState([]);

  const [clientType, setClientType] = useState('')
  const [addClientType, setAddClientType] = useState('')
  const [clientTypeerror, setClientTypeError] = useState('')
  const [setTypeClient,setSelectedTypeClient] = useState([]);
  const [setAddTypeClient,setAddSelectedTypeClient] = useState([]);

  // add group to Devices
  const [errorDevicesMessage, setDeviceErrorMessage] = useState('');
  const [errorClientMessage, setClientErrorMessage] = useState('');
  const [errorGroupMessage, setGroupErrorMessage] = useState('');

  const [dilogClient,setDilogClient] = useState(null)
  
  const [checkValue,setCheckValue]=useState(false)

  const [openAuto,setOpenAuto]=useState(false)
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocation, setSelectedClientLocation] = useState(null);

  const getEffectiveClientType = () => (isReseller ? effectiveResellerClientType : clientType);
  const getEffectiveAddClientType = () => (isReseller ? effectiveResellerClientType : addClientType);

  const handleGroupReload = (val)=>{
    
    loadClientGroupInfo(client, clientLocationOptions)
    
  }


  useEffect (()=>{

    getClientList((response) => {
      if (response.status === 200) {
         setClientInfo(response.data)
      }
    })

    getGroups((response)=>{
      setGroup(response.data)
    })


    let _body = { status: "1", limit: 0 }
    getDevices(_body, (response) => {
      let totalCams=response.data;
      if (response.status == 200) { 
        setDevices(response.data)      
      }
    })

  },[])

  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const buildClientInfoClientId = (fallbackClientId, locationItems = []) => {
    const locationIds = (Array.isArray(locationItems) ? locationItems : [])
      .map((locationItem) => Number(locationItem?.ID ?? locationItem?.id ?? 0))
      .filter((locationId) => locationId > 0);

    return locationIds.length > 0 ? locationIds.join(',') : fallbackClientId;
  };

  const loadClientGroupInfo = (clientId, locationItems = []) => {
    const body = {
      group_id: 0,
      client_id: buildClientInfoClientId(clientId, locationItems)
    };

    getClientInfo(body, (response) => {
      setClientData(response.data);
    });
  };

  const buildGroupPayloadClientId = (fallbackClientId, selectedLocationIds = []) => {
    const normalizedLocationIds = (Array.isArray(selectedLocationIds) ? selectedLocationIds : [])
      .map((locationId) => Number(locationId))
      .filter((locationId) => locationId > 0);

    return normalizedLocationIds.length > 0 ? normalizedLocationIds.join(',') : fallbackClientId;
  };

  const buildUniqueClientOptions = (clients) => {
    const grouped = new Map();

    (clients || []).forEach((clientItem) => {
      const key = normalizeDisplayName(clientItem?.displayname);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key).push(clientItem);
    });

    return Array.from(grouped.values()).map((groupItems) => {
      if (groupItems.length === 1) return groupItems[0];

      const assignTargets = new Set(
        groupItems
          .map((item) => Number(item.AssignClient || 0))
          .filter((assignId) => assignId > 0)
      );

      const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
      if (mappedMain) return mappedMain;

      const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
      return rootEntry || groupItems[0];
    });
  };

  const uniqueClientOptions = useMemo(
    () => buildUniqueClientOptions(setTypeClient || []),
    [setTypeClient]
  );

  useEffect(() =>{
    const effectiveType = getEffectiveClientType();
    if(effectiveType === "INDIA"){
      // console.log("clientType",clientType)
     const indiaClients = clientInfo.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType !==0 );
     const sortedData = [...indiaClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
     setSelectedTypeClient(sortedData)
    }
    else if(effectiveType === "US") {
     const usClients = clientInfo.filter((row) => row.ClientType === 'US' && row.EnvironmentType !==0 );
     const sortedData = [...usClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
     setSelectedTypeClient(sortedData)
    //  const usClientsSub = subLogin.filter((row) => row.ClientType === 'US');

    //  setSubLoginSelectList(usClientsSub)

    }

  },[clientType,clientInfo,isReseller,effectiveResellerClientType])


  useEffect(() =>{
    const effectiveAddType = getEffectiveAddClientType();
    if(effectiveAddType === "INDIA"){
     const indiaClients = clientInfo.filter((row) => row.ClientType === 'INDIA');
     const sortedData = [...indiaClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
     setAddSelectedTypeClient(buildUniqueClientOptions(sortedData))
    }
    else if(effectiveAddType === "US") {
     const usClients = clientInfo.filter((row) => row.ClientType === 'US');
     const sortedData = [...usClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
     setAddSelectedTypeClient(buildUniqueClientOptions(sortedData))
    }
    else{
      setAddSelectedTypeClient([])
    }

  },[addClientType,clientInfo,isReseller,open,effectiveResellerClientType])

  const onAddClientChange = (e,val) =>{
    
    setClientError(false)
    if(val){
      
      let id = val.ID
      setDilogClient(id)
    }
    else{
      setDilogClient(null)
    }
  }


  const onClientChange = (event,value)=>{

    // console.log(selectedGroup)
    setDeviceErrorMessage('')
    setClientErrorMessage('')
    setGroupErrorMessage('')
    //setClientCameras([])
    setActiveCameras([])
    setOpenAuto(false)
    setClientGroups([])
    setClientLocationOptions([]);
    setSelectedClientLocation(null);

    setSelectedGroup(null)

    if(!value || value.length===0){
      setActiveCameras([])
      setInputValue([])
      setClientData([])
    }
    setCheckValue(false)
    let id=''
    // setSelectedCameras('')
    // setSelectedGroup(0)
    setSelectedCameras([]);
    
      if(!value)
      {
        setClient('');
        setClientCameras([]);
        setSelectedCameras([]);
        setSelectedClient(null);
      }
      else{
        setClientErrorMessage('')
        setSelectedClient(value);
        //console.log(grou)
        id=value.ID
          setClient(id)
          const data = {client_id:id}
          getGroupsByClient(data,(res)=>{
            console.log(res)
            if(res.status === 200){
              if(res.data.length > 0){
                setClientGroups(res.data)
              }
            }
          })

          getClientProperties({ AssignClient: String(id) }, (response) => {
            if (response.status === 200) {
              const normalizedLocations = Array.from(
                new Map(
                  (Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []))
                    .map((locationItem) => ({
                      ...locationItem,
                      ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
                      Location: String(locationItem?.Location || locationItem?.name || '').trim(),
                    }))
                    .filter((locationItem) => locationItem.ID > 0)
                    .map((locationItem) => [locationItem.ID, locationItem])
                ).values()
              );
              setClientLocationOptions(normalizedLocations);

              if (normalizedLocations.length > 0) {
                loadClientGroupInfo(id, normalizedLocations);
                setClientCameras([]);
                return;
              }
            }

            loadClientGroupInfo(id, []);
            const clientCams = devices.filter(item => Number(item.clientid) === Number(id));
            setClientCameras(clientCams);
          });
      }
  }

  const handleFilterByName = event => {
    setFilterName(event.target.value);
    // Perform additional filtering based on the selected client if needed
  };

  const handleOpen = () => {
    setGroupName("");
    setOpen(true);
  };

  const handleCameraChange = (event,value) =>{
    let actCams=[];
    if (value.some(obj => obj.hasOwnProperty('selectall'))){
      if(activeCameras.length===clientCameras.length){
        setActiveCameras([])
        setCheckValue(false)
      }
      else{
        clientCameras.forEach(item=>{
          actCams.push(item.deviceid)
        })
        setActiveCameras(actCams)
        setCheckValue(true)
      }
    }
    else{
      let id=value[0].deviceid;
      if(activeCameras.includes(id)){
        let filterArr = activeCameras.filter(divid => divid !== id);
        setActiveCameras(filterArr);
        if(checkValue){
          setCheckValue(false)
        }
      }
      else{
        setActiveCameras((prv)=>[...prv,id])
      }
    }
  }

  const handleLocationChange = (event, value) => {
    const nextSelectedLocation = value ? (value.ID || value.id) : null;

    setSelectedClientLocation(nextSelectedLocation);

    setActiveCameras([]);
    setInputValue([]);
    setCheckValue(false);
    setSelectedCameras([]);
    setOpenAuto(false);
    setDeviceErrorMessage('');

    if (!nextSelectedLocation) {
      setClientCameras([]);
      return;
    }

    const filteredCameras = (devices || []).filter((item) => {
      const deviceClientId = String(item?.clientid ?? item?.client_id ?? item?.ClientId ?? '');
      return deviceClientId !== '' && deviceClientId === String(nextSelectedLocation);
    });

    setClientCameras(filteredCameras);
  };

  useEffect(()=>{   
    if(activeCameras.length===clientCameras.length && activeCameras.length>0){
      setCheckValue(true)
    }
  },[activeCameras])

  useEffect(() => {
    if (!client || clientLocationOptions.length === 0) return;

    if (!selectedClientLocation) {
      setClientCameras([]);
      return;
    }

    const filteredCameras = (devices || []).filter((item) => {
      const deviceClientId = String(item?.clientid ?? item?.client_id ?? item?.ClientId ?? '');
      return deviceClientId !== '' && deviceClientId === String(selectedClientLocation);
    });
    setClientCameras(filteredCameras);
  }, [client, clientLocationOptions, selectedClientLocation, devices]);
  
  // const handleCameraChange = (event, value) => {
  //   if (value.some(obj => obj.hasOwnProperty('all'))) {
  //     if(value[0].all){
  //       //let x=value[0].all
  //       setOpenAuto(true);
  //     }
  //     else{
  //       setOpenAuto(false);
  //     }
  //   } else {
  //     setOpenAuto(true);
  //   }
  
  //   if (value.length > 1 && value.every((entry, index, arr) => JSON.stringify(entry) === JSON.stringify(arr[0]))) {
  //     value = [];
  //   }
    
  //   const containsAllProperty = value.some(obj => obj.hasOwnProperty('all'));
  
  //   if (value.length === 0 || !containsAllProperty) {
  //     setCheckValue(false);
  //   }
  
  //   let actCameras = [];
  //   setDeviceErrorMessage('');
  
  //   if (value.length > 0 && !containsAllProperty) {
  //     value.forEach((row) => {
  //       actCameras.push(row.deviceid);
  //     });
  
  //     if (clientCameras.length === actCameras.length) {
  //       setCheckValue(true);
  //       setOpenAuto(false);
  //     }
  
  //     setActiveCameras([...actCameras]);
  //     setInputValue([...value]);
  //   }
  
  //   if (value.length > 0 && containsAllProperty) {
  //     let Cameras = clientCameras;
  
  //     actCameras = [];
  
  //     if (activeCameras && activeCameras.length === clientCameras.length) {
  //       setCheckValue(false);
  //       const deviceIds = value.filter(obj => !obj.hasOwnProperty('all')).map(obj => obj.deviceid);
  //       Cameras = Cameras.filter(item => !deviceIds.includes(item.deviceid));
  //       Cameras.forEach((row) => {
  //         actCameras.push(row.deviceid);
  //       });
  //       setActiveCameras([...actCameras]);
  //       setInputValue(clientCameras);
  //       //setOpenAuto(false);
  //       return;
  //     }
  //     if (!checkValue) {
  //       Cameras.forEach((row) => {
  //         actCameras.push(row.deviceid);
  //       });
  //       setActiveCameras([...actCameras]);
  //       setInputValue(clientCameras);
  //       setCheckValue(true);
  //     } else {
  //       setActiveCameras([]);
  //       setInputValue([]);
  //     }
  //   } else if (value.length === 0) {
  //     setActiveCameras([]);
  //     setCheckValue(false);
  //     setInputValue([]);
  //   }
  // };
  
  // const handleCameraChange = (event, value) => {   
  //   if(value.length===clientCameras.length || value.some(obj => obj.hasOwnProperty('all'))){
  //     setOpenAuto(false)
  //   }
  //   else{
  //     setOpenAuto(true)
  //   }

  //   if(value.length>1 && value.every((entry, index, arr) => JSON.stringify(entry) === JSON.stringify(arr[0]))){
  //     value=[];
  //   }
  //     const containsAllProperty = value.some(obj => obj.hasOwnProperty('all'));

  //     if (value.length === 0 || !containsAllProperty) {
  //       setCheckValue(false);
  //     }
      
  //     let actCameras = [];
  //     setDeviceErrorMessage('');
      
  //       if (value.length > 0 && !containsAllProperty) {
        
  //         value.forEach((row) => {
  //         actCameras.push(row.deviceid);
  //       });
  
  //       if(clientCameras.length===actCameras.length){
  //         setCheckValue(true)
  //         //setOpenAuto(false)
  //       }
       
  //       setActiveCameras([...actCameras]);
  //       setInputValue([...value]);
  //     }
  
  //     if(value.length>0 && containsAllProperty){  // checked select all
  //       let Cameras=clientCameras
        
  //       actCameras = []; 
        
  //       if(activeCameras && activeCameras.length===clientCameras.length){ // uncheck select all and camera
          
  //         setCheckValue(false)
  //         const deviceIds = value.filter(obj => !obj.hasOwnProperty('all')).map(obj => obj.deviceid);
  //         Cameras=Cameras.filter(item=>!deviceIds.includes(item.deviceid))
  //         Cameras.forEach((row) => {
  //           actCameras.push(row.deviceid);
  //         });
  //         setActiveCameras([...actCameras]);
  //         setInputValue(clientCameras);
  //         //setOpenAuto(false)
  //         return
  //       }
  //       if(!checkValue){       // if select all is true (false prv) need to load all cameras
  //         Cameras.forEach((row) => {
  //           actCameras.push(row.deviceid);
  //         });
  //         setActiveCameras([...actCameras]);
  //         setInputValue(clientCameras);
  //         setCheckValue(true)
  //         //setOpenAuto(false)
  //       }
  //       else{                 // if select all is false need to empty all state variables
  //         setActiveCameras([]);
  //         setInputValue([]);
  //         //handleReload()
  //       }
  //     }
  //     else if(value.length === 0){ 
  //       setActiveCameras([]);
  //       setCheckValue(false)
  //       setInputValue([]);
  //     }  
  // };
  
  const handleClose = () => {
    setOpen(false);
    setOpenError(false);
    setGroupNameError(false);
    setClientNameError(false)
    setClientError(false)
    setHelperText('')
    setAddClientType('')
  };

  const saveGroupName1 = ()=>{


    if (groupName.trim() === '') {
      setGroupNameError(true);
    }
    else {



    let body = { GroupName: groupName };

    AddClientGroupName(body,(response)=>{
       // console.log(response)
      
        setGroupName("");
        setOpen(false);

        if(response.status===200){
          getGroups((response)=>{
            setGroup(response.data)
            setOpenError(true)
            setMessage('Group Name Added Successfully')
          })
        }   
    })
    setGroupNameError(false);
  }
  }


  const saveGroupName = () => {
    
    let ClientType = addClientType;
    let clientId = dilogClient;

    let hasError = false;

    //return;
    if(!ClientType && !isReseller){
      setClientNameError(true)
      setClientMessage('Please Select Client Type')
      hasError = true
    }

    if(!clientId){
      setClientError(true)
      setClientNameMessage('please Select Client')
      hasError = true
    }

    if (groupName.trim() === '') {
      setGroupNameError(true);
      setMessage('Group Name cannot be empty.')
      hasError = true
    } 
    
    if(hasError){
      return
    }
     
      const isGroupNameExists =group?group.some(group => group.GroupName.toLowerCase() === groupName.toLowerCase()):'';
  
      if (isGroupNameExists) {
        setGroupNameError(true);
        //setErrorMessage()
        setMessage('Group Name already exists');
      } else {
        let body = { GroupName: groupName , ClientId : clientId};
  
        AddClientGroupName(body, (response) => {
          setGroupName("");
          setOpen(false);
  
          if (response.status === 200) {
            getGroups((response) => {
              setGroup(response.data);
              setOpenError(true);
              setMessage('Group Name Added Successfully');
            });
            if (client && clientId === client) { 
            const data = { client_id: client };
            getGroupsByClient(data, (res) => {
              if (res.status === 200) {
                setClientGroups(res.data);
                
                
	                loadClientGroupInfo(client, clientLocationOptions);
	              }
	            });
	          }
          }
        });
        setGroupNameError(false);
      }
    
  };
  

  const handleSave = () => {
    // if (!activeCameras || !client || !selectedGroup) {
    //   setErrorMessageOpen(true);
    // } 
    if (activeCameras.length === 0 || !client || !selectedGroup) {
      if(client === ''){
        setClientErrorMessage("Please Select client")
      }
      if(activeCameras.length === 0){
        setDeviceErrorMessage("Please Select Atleast One Camera")
      }
      if(selectedGroup === 0){
        setGroupErrorMessage("Please Select the Group")
      }

    if(!clientTypeerror){
      setClientTypeError("Please select the client Type")
      
    }

    setErrorMessageOpen(true);
  }
    else {
      // console.log(selectedCameras)
      // console.log(clientData)

    
      let presentValues = activeCameras.filter(id => clientData.map(item => item.deviceid).includes(id));
      
      if(presentValues.length>0){
            // groups are not editable from here
            setMessage('Groups cannot be edited from here')
            setOpenError(true)
      }
      else{
	        const payloadClientId = buildGroupPayloadClientId(
	          client,
	          selectedClientLocation ? [selectedClientLocation] : []
	        );
	        let body=activeCameras.map(item=>{
	          return {
	            GroupId: selectedGroup.Id,
	            DeviceId: item,
	            ClientId: payloadClientId
	          }
	        })
  
	        AddClientGroup(body,(response)=>{
	          if(response.status===200){
	            loadClientGroupInfo(client, clientLocationOptions)

	            setSelectedClient(null);
            setClient('');
	            setClientLocationOptions([]);
	            setSelectedClientLocation(null);
            setClientCameras([]);
            setSelectedCameras([]);
            setActiveCameras([]);
            setInputValue([]);
            setCheckValue(false);
            setSelectedGroup(null);
            setClientErrorMessage('');
            setDeviceErrorMessage('');
            setGroupErrorMessage('');
          }
        })

        //setClient('');
        //setClientCameras([]);
        //setSelectedCameras([]);
        //setClientData([])
        // setSelectedGroup()
      }
         
    }
  };

  const handleErrorMessageClose = () => {
    setErrorMessageOpen(false);
  };

  // const handleGroupNameChange = event => {
  //   setGroupName(event.target.value);
  // };

  const onGroupChange = (event,value) =>{
    if(value){
      setSelectedGroup(value)
      setGroupErrorMessage('')
    }
    else{
      setSelectedGroup(null)
    }
  }

  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    
    // Separate selected and unselected options
    const selectedOptions = filtered.filter(option => activeCameras.includes(option.deviceid));
    const unselectedOptions = filtered.filter(option => !activeCameras.includes(option.deviceid));
    
    // Sort options: selected options first, then unselected
    const sortedOptions = [...selectedOptions, ...unselectedOptions];

    return [{ title: 'Select All', selectall: true }, ...filtered];
  };

  const handleAddClientType = (e) =>{
    setClientNameError(false)
    setAddClientType(e.target.value)
  }

  const handleClientType = (event) =>{
    // console.log("client type",event.target.value)
    setClientType(event.target.value)
    setClientTypeError('')
  }

  const showLocationDropdown = Boolean(selectedClient && clientLocationOptions.length > 0);
  const compactLayout = showLocationDropdown;


  return (
    <Page title="Groups">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Groups</Typography>
            <Button
              variant="contained"
              onClick={() => handleOpen()}
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              Add Group
            </Button>
            
            <Dialog open={open} maxWidth="md" fullWidth>
              <DialogTitle>Add Group</DialogTitle>
                  {/* Add camera form fields */}
                    <DialogContent>
                    
                    <Grid container spacing={3}>
                     {!isReseller && <Grid item md={4} mt={1}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-labell" sx={{ color: clientNameError ? 'error.main' : 'inherit' }}>Client Type</InputLabel>
                          <Select                     
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={addClientType}
                            label="Client Type"
                            onChange={handleAddClientType}
                            // helperText={clientNameError ? clientMessage : ''}
                            error={clientNameError  ? true : false }
                          >                     
                            <MenuItem value="US">US</MenuItem>
                            <MenuItem value="INDIA">INDIA</MenuItem>
                          </Select>
                          {clientNameError && (
                            <FormHelperText sx={{ color: 'error.main' }}>{clientMessage}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>}
                      
                      <Grid item md={4} mt={1}>
                        <FormControl fullWidth>
                          <Autocomplete
                            fullWidth
                            id="tags-outlined"
                            options={setAddTypeClient.map((client, clientIndex) => ({
                              ...client,
                              customKey: clientIndex, // Assuming clientId is a unique identifier
                            }))}
                            isOptionEqualToValue={(option, value) =>
                              Number(option.ID) === Number(value?.ID)
                            }
                            getOptionLabel={(option) =>  `${option.displayname}`}
                            onChange={onAddClientChange}
                            value={setAddTypeClient.find((clientItem) => Number(clientItem.ID) === Number(dilogClient)) || null}
                            //filterSelectedOptions
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Clients"
                                placeholder="Enter Client Name"
                                helperText={clientError ? clientNameMessage : ''}
                                error={clientError  ? true : false }
                              />
                            )}
                            renderOption={(props, option) => (
                              <li {...props} key={option.customKey}>
                                {option.displayname}
                              </li>
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item md={4} mt={1}>
                        <FormControl fullWidth>
                          <TextField
                              id="groupName"
                              label="Group Name"
                              type="text"
                              fullWidth
                              value={groupName}
                              onChange={(e) => {
                                  const newName = e.target.value;
                                  setGroupName(newName);
                                  setGroupNameError(false); // Reset error state when typing
                                  // Check if the new name exists in the list
                                  // if (groupName.includes(newName)) {
                                  //     setGroupNameError(true);
                                  //     setHelperText("Group name already exists.");
                                  // } else 
                                  if (newName.trim() === "") { // Check if the field is empty
                                      setGroupNameError(true);
                                      setHelperText("Group Name cannot be empty.");
                                      setMessage('')
                                  } else {
                                      setGroupNameError(false);
                                      setHelperText(""); // Clear helper text if no error
                                  }
                              }}
                              error={groupNameError}
                              helperText={helperText}
                              required
                          />
                        </FormControl>
                      {groupNameError && (<Typography color="error.main" fontSize={12}>{message}</Typography>)}
                      </Grid>

                    </Grid>                  
                  </DialogContent>
                  <DialogActions>
                    <Button color='error' variant='outlined' onClick={handleClose}>Close</Button>
                    <Button type="submit"  onClick={saveGroupName} variant="contained">Save</Button>
                  </DialogActions>
            </Dialog>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Settings</Typography>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Groups</Typography>
          </Breadcrumbs>
        </Box>

        <Card sx={{ p: 2 }}>
          <Grid container spacing={2} alignItems="flex-start">
            {!isReseller && <Grid item xs={12} sm={6} md={compactLayout ? 2 : 2}>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-labell">Client Type</InputLabel>
                        <Select
                          
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={clientType}
                          label="Client Type"
                          onChange={handleClientType}
                          // helperText={touched.ClientType && errors.ClientType}
                          // error={clientTypeerror  ? true : false }
                        >
                          
                          <MenuItem value="US">US</MenuItem>
                          <MenuItem value="INDIA">INDIA</MenuItem>

                      </Select>
                      {clientTypeerror  && <Typography variant="body2" color="error">{clientTypeerror}</Typography>}


                        </FormControl>
                        
                      
                        </Grid>}

            <Grid item xs={12} sm={6} md={compactLayout ? 2 : 3}>
              <FormControl fullWidth>
                <Autocomplete
                  fullWidth
                  id="tags-outlined"
                  options={uniqueClientOptions.map((clientItem, clientIndex) => ({
                    ...clientItem,
                    customKey: `${clientItem.ID || clientItem.id}-${clientIndex}`,
                  }))}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID}
                  getOptionLabel={(option) => `${option.displayname || ''}`}
                  onChange={onClientChange}
                  value={selectedClient}
                  //filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Clients"
                      placeholder="Enter Client Name"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.customKey}>
                      {option.displayname}
                    </li>
                  )}
                />
            </FormControl>
              {errorClientMessage && <Typography color="error" variant="body2" align="left">{errorClientMessage}</Typography>}
            </Grid>

	            {showLocationDropdown && (
	              <Grid item xs={12} sm={6} md={2}>
	                <Autocomplete
	                  fullWidth
	                  id="locations"
	                  options={clientLocationOptions}
	                  value={
	                    clientLocationOptions.find(
	                      (locationItem) => Number(locationItem.ID || locationItem.id) === Number(selectedClientLocation)
	                    ) || null
	                  }
	                  getOptionLabel={(option) => `${option.Location || ''}`}
	                  onChange={handleLocationChange}
	                  renderOption={(props, option) => (
	                    <li {...props}>
	                      {option.Location}
	                    </li>
	                  )}
	                  renderInput={(params) => (
	                    <TextField {...params} label="Location" placeholder="Select Location" />
	                  )}
	                />
	              </Grid>
	            )}
            
            <Grid item xs={12} sm={6} md={compactLayout ? 2 : 3}>

            <Autocomplete
              multiple
              fullWidth
              id="camera"
              options={clientCameras}
              
              //value={(checkValue) ? [{ title: 'Select All', all: true }] : inputValue.filter((camera) => activeCameras.includes(camera.deviceid))}
              value={[]}

              getOptionLabel={(option) => (option.selectall && clientCameras.length === activeCameras.length) ? 'Select All' : `${option.deviceid} ${option.devicename}`}
              onChange={handleCameraChange}
              disableCloseOnSelect={openAuto}
              open={openAuto}
              onOpen={() => setOpenAuto(true)}
              onClose={() => setOpenAuto(false)}
              
              // filterOptions={(options, params) => {
              //   const filter = createFilterOptions();
              //   const filtered = filter(options, params);
              //   return [{ title: 'Select All', selectall: true }, ...filtered];
              // }}

              filterOptions={handleFilterOptions}
              
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  {option.selectall ? (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={checkValue}
                        //onChange={() => setCheckValue(!checkValue)}
                      />
                      {option.title}
                    </>
                  ) : (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={activeCameras.includes(option.deviceid)}
                        onChange={() => {
                          const isChecked = activeCameras.includes(option.deviceid);
                          const newActiveCameras = isChecked
                            ? activeCameras.filter((deviceId) => deviceId !== option.deviceid)
                            : [...activeCameras, option.deviceid];
                          setActiveCameras(newActiveCameras);
                        }}
                      />
                      {`${option.devicename}`}
                    </>
                  )}
                </li>
              )}
              renderInput=
              {(params) => 
                <TextField {...params} label="Camera" onFocus={() => setOpenAuto(true)}/>
              }
            />

            
            
            {errorDevicesMessage && <Typography color="error" variant="body2" align="left">{errorDevicesMessage}</Typography>}
            </Grid>
            
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth>

              <Autocomplete
                  fullWidth
                  // options={group || []}
                  options={(clientGroups || []).map((group, groupIndex) => ({
                    ...group,
                    customKey: groupIndex, // Assuming customKey is a unique identifier
                  }))}
                  isOptionEqualToValue={(option, value) => option.customKey === value.customKey}
                  getOptionLabel={(option) => option.GroupName}
                  value={selectedGroup}
                  onChange={onGroupChange}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Groups"
                      placeholder="Select Group"
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.customKey}>
                      {option.GroupName}
                    </li>
                  )}
                />
              </FormControl>
              {errorGroupMessage && <Typography color="error" variant="body2" align="left">{errorGroupMessage}</Typography>}
            </Grid>
            
            <Grid item xs={12} sm={6} md={2} sx={{ display: 'flex', alignItems: 'flex-start' }} mt={2}>
              <Button variant="contained" size="small" onClick={handleSave}>
                Save
              </Button>
            </Grid>

          </Grid>

          <TableContainer sx={{
            mt: 2,
            maxHeight: 600,
            "&::-webkit-scrollbar": { width: 6, height: 6 },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": { backgroundColor: alpha(theme.palette.text.primary, 0.2), borderRadius: 3 },
            "&::-webkit-scrollbar-thumb:hover": { backgroundColor: alpha(theme.palette.text.primary, 0.35) },
          }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>S.No</TableCell>
                <TableCell sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Client Name</TableCell>
                <TableCell sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Location</TableCell>
                <TableCell sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Camera Name</TableCell>
                <TableCell sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Group Name</TableCell>
                <TableCell sx={{ bgcolor: 'background.neutral' }} />
              </TableRow>
            </TableHead>
          <TableBody>
        {clientData.map((row, index) => (
          <TableRow key={index} hover>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{row.DisplayName}</TableCell>
            <TableCell>{row.Location}</TableCell>
            <TableCell>{row.devicename}</TableCell>
            <TableCell>{row.GroupName}</TableCell>
            <TableCell><GroupsMore row={row} groups={group} handleGroupReload={handleGroupReload}/></TableCell>
            
          </TableRow>
        ))}
          </TableBody>
          </Table>
          </TableContainer>

        </Card>

        <Dialog open={openError} onClose={handleClose} maxWidth="xs" fullWidth>
          <DialogTitle>Add Group</DialogTitle>
            <DialogContent>
                      {message}
            </DialogContent>
          <DialogActions>
            <Button color='error' variant='outlined' onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

export default Groupsdetails;
// in onchange user makes Empty Client and then automatically clear the camera Fields
